import React, { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Stack } from '@mui/material';
import { Icons } from 'src/components/icons';

interface UsersTableActionsProps {
  item: Record<string, any>;
  onEdit: (id: string | number) => void;
}

export const UsersTableActions: ComponentType<UsersTableActionsProps> = ({ item, onEdit }) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row">
      <>
        <IconButton
          onClick={() => onEdit(item.id)}
          color="info"
          aria-label={t('action.edit', 'Редактировать')}
          size="small"
        >
          <Icons.Pencil />
        </IconButton>
      </>
    </Stack>
  );
};
